import axios from "axios"
import { CONST_API_RECRUITMENT_VIVIERS_POST_CREATE_ENDPOINT } from "../../../../../endpoints"
import { ICreateVivierRequestModel } from "./_models"

export function createVivierRequest(payload: ICreateVivierRequestModel) {
     return axios.post(CONST_API_RECRUITMENT_VIVIERS_POST_CREATE_ENDPOINT, payload)
}
